import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import type { U2104AffiliationActionHandler } from "./U2104AffiliationActionHandlers";
import type { U2104LogicalUnit } from "../../../../U2104Service";

// Typage des props du composant
interface U2104AffiliationActionDeleteDlgProps {
  u2104AffiliationActionHandler: U2104AffiliationActionHandler;
  t: TFunction;
  NS: string;
}

function U2104AffiliationActionDeleteDlg({ u2104AffiliationActionHandler, t, NS }: U2104AffiliationActionDeleteDlgProps) {
  if (!u2104AffiliationActionHandler.isDeleteDialogOpen) return null;

  return (
    <U2000DeleteRecordDialog isOpen={u2104AffiliationActionHandler.isDeleteDialogOpen} onClose={u2104AffiliationActionHandler.onDlgDeleteClose} title={t("lblDeleteDlgTitle", { ns: NS })}>
      <p className="mb-4">
        {t("user.msgDeleteUserAction", {
          count: u2104AffiliationActionHandler.gridStateHandlers.getSelectedRows().length,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {u2104AffiliationActionHandler.gridStateHandlers.getSelectedRows().map((row, index, array) => {
          const lu = row as unknown as U2104LogicalUnit;
          return (
            <span key={lu.logicalUnitCode} className="inline-block text-gray-800">
              {`${lu.logicalUnitCode} - ${lu.logicalUnitDescription}`}
              {index < array.length - 1 && ", "}
            </span>
          );
        })}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U2104AffiliationActionDeleteDlg;
